// extracted by mini-css-extract-plugin
module.exports = {"chartArea":"ViewsDetailsTile_chartArea__VoJ_R"};